module.exports = __webpack_public_path__ + "static/thebottleshop_logo-29f91bc7bf6fb372b2ca6186b072109e.png";